<template>
	<helio-slider :slides="slides" />
</template>

<script>
import { translationMixin } from '@/mixins';
/* eslint-disable global-require */
export default {
	name: 'Slider',
	mixins: [translationMixin],
	data() {
		return {
			slides: [],
		};
	},
	computed: {
		translation() {
			return this.currentTranslation.slider;
		},
	},
	created() {
		this.slides = [
			{
				title: this.translation['title-1'],
				subtitle: this.translation['subtitle-1'],
				image: require('@/assets/c_slider_crm.jpg'),
				button: {
					text: this.translation['button-title-1'],
					link: this.translation['link-1'],
					target: '_blank',
				},
			},
			{
				title: this.translation['title-2'],
				subtitle: this.translation['subtitle-2'],
				image: require('@/assets/c_slider_sites.jpg'),
				button: {
					text: this.translation['button-title-2'],
					link: this.translation['link-2'],
					target: '_blank',
				},
			},
			{
				title: this.translation['title-3'],
				subtitle: this.translation['subtitle-3'],
				image: require('@/assets/c_slider_portail_client.jpg'),
				button: {
					text: this.translation['button-title-3'],
					link: this.translation['link-3'],
					target: '_blank',
				},
			},
			{
				title: this.translation['title-4'],
				subtitle: this.translation['subtitle-4'],
				image: require('@/assets/c_slider_aide.jpg'),
				button: {
					text: this.translation['button-title-4'],
					link: this.translation['link-4'],
					target: '_blank',
				},
			},
		];
	},
};
</script>
